// Auto-open location selector popup if user has no locationData in localStorage
(function () {
  function init() {
    autoOpenIfNoLocationData();
    handleCountryRedirects();
  }

  function autoOpenIfNoLocationData() {
    const locationData = localStorage.getItem('locationData');
    if (!locationData && window.locationSelectorPopup) {
      window.locationSelectorPopup.open();
    }
  }

  function handleCountryRedirects() {
    const popup = document.getElementById('cs-location-selector-popup');
    if (!popup) return;

    // 1. Click directo en una opción con data-url → redirigir inmediatamente
    // Se attacha directo al elemento porque el JS original usa stopPropagation
    const options = popup.querySelectorAll('.cs-location-selector-popup__select-option[data-url]');
    options.forEach((option) => {
      option.addEventListener('click', () => {
        const url = option.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });

    // 2. Al confirmar el formulario con un país que tiene data-url → redirigir
    const form = popup.querySelector('#cs-location-selector-form');
    if (form) {
      form.addEventListener('submit', () => {
        const countryInput = popup.querySelector('#location-country');
        if (!countryInput) return;
        const selectedOption = popup.querySelector(
          `.cs-location-selector-popup__select-option[data-value="${countryInput.value}"][data-url]`
        );
        if (selectedOption) {
          window.location.href = selectedOption.getAttribute('data-url');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
